import { render, staticRenderFns } from "./Age.vue?vue&type=template&id=3cc1a6c1&scoped=true"
import script from "./Age.vue?vue&type=script&lang=js"
export * from "./Age.vue?vue&type=script&lang=js"
import style0 from "./Age.vue?vue&type=style&index=0&id=3cc1a6c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc1a6c1",
  null
  
)

export default component.exports